import React from "react";
import { Dialog, DialogTitle, DialogContent, Typography } from "@mui/material";
import Slider from "react-slick";
import { Animal } from "src/services/types";

interface AnimalDialogProps {
  open: boolean;
  onClose: () => void;
  animal: Animal;
}

const AnimalDialog: React.FC<AnimalDialogProps> = ({
  open,
  onClose,
  animal,
}) => {
  const settings = {
    dots: animal.photos && animal.photos.length > 1,
    infinite: animal.photos && animal.photos.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: animal.photos && animal.photos.length === 1,
    centerPadding:
      animal.photos && animal.photos.length === 1 ? "0" : undefined,
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>{animal.name}</DialogTitle>
      <DialogContent>
        <Slider {...settings}>
          {animal.photos?.map((photo, index) => (
            <div
              key={index}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <img
                src={photo}
                alt={`Animal ${index}`}
                style={{
                  maxWidth: "100%",
                  maxHeight: "400px",
                  objectFit: "contain",
                }}
              />
            </div>
          ))}
        </Slider>
        <Typography variant="h6" gutterBottom>
          Especie: {animal.specie}
        </Typography>
        <Typography variant="body1" gutterBottom>
          Edad: {animal.age} años
        </Typography>
        {animal.description && (
          <Typography variant="body2" color="textSecondary">
            {animal.description}
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default AnimalDialog;
